import React, { useEffect } from 'react'

import * as S from './styled'
import Title from './Title'
import Prepare from './Prepare'

const DetailList = () => {

  useEffect(() => {
    window.addEventListener('onpopstate', () => {
      localStorage.setItem('detail-back-event', 'true')
    })

    return () => {
      window.removeEventListener('onpopstate', () => {})
    }
  }, [])

  return (
    <S.DetailListContainer>
      <Title />
      <Prepare />
    </S.DetailListContainer>
  )
}

export default DetailList
